import CXMApiClient from "../../CXMApiClient";
import moment from "moment";

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  loadGroupedActivityDetail: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/grouped/detail",
          request.filter,
          request.scope
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loadGroupedActivitySummary: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/grouped/summary",
          request.filter,
          request.scope
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loadActivityGroups: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("post", "/api/activitygroup", request)
        .then(response => {
          if (response && response.data.successful) {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveActivityGroup: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("post", "/api/activitygroup/activitygroups", request)
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteActivityGroup: function(context, activityGroupId) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("delete", `/api/activitygroup/${activityGroupId}`)
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboards/ActivityGroups.js